import { useCallback, useMemo } from "react";
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { useGetRequest } from "../ApiWrappers/useGetRequest";

export enum ClinicStorageError{
    NONE = "NONE",
    NO_LICENSE = "NO_LICENSE",
    ACTIVE_LICENSE = "ACTIVE_LICENSE",
    EXPIRED_LICENSE = "EXPIRED_LICENSE",
    DEACTIVATED = "DEACTIVATED"
}

export interface IStorageLicenceInfo {
    clinicId : string,
    totalMaxStorageInGb: number,
    totalAvailableStorageInGb: number,
    licenseEndDate: string,
    storageError:ClinicStorageError,
    entitlementId:string;
}

export const useGetClinicStorageInfo = () => {
  const baseUrl = useMemo(() => Config.GetConfigData().auraStorageLicensingService.serviceUrl,[]);
  const scope = Config.GetConfigData().auraStorageLicensingService?.scopes[0];
  const [getDetails, data, loading, error] = useGetRequest<IStorageLicenceInfo>()

  const getClinicStorageInfo = useCallback((clinicId:string) => {
      const requestUrl = `${baseUrl}api/v1/clinic/${clinicId}/license`;
      getDetails(scope, requestUrl);
  }, [getDetails, baseUrl, scope]);
    return { 
      getClinicStorageInfo,
      data,
      loading,
      error
   };
}